import type { IBooleanResponse } from '@types'
import type { IAiAnalysis, IStock } from '~/@types/assets'
import Api from '@api/Api'

export default abstract class AssetsAdapter {
  public static async get(id: string): Promise<IStock> {
    return Api.get<IStock>(`/assets/${id}`)
  }

  public static async tickerSuggest(ticker: string): Promise<Array<string>> {
    return Api.get<Array<string>>(`/suggest/${ticker}`)
  }

  public static async stockSearch(symbol: string): Promise<IStock> {
    return Api.get<IStock>(`/assets/search/stock/${symbol}`)
  }

  public static async runAiAnalysis(id: string): Promise<IAiAnalysis> {
    return Api.get<IAiAnalysis>(`/assets/${id}/analysis`)
  }

  public static async watchAsset(id: string): Promise<boolean> {
    const res = await Api.get<IBooleanResponse>(`/assets/${id}/watch`)
    return res.success
  }

  public static async unwatchAsset(id: string): Promise<boolean> {
    const res = await Api.get<IBooleanResponse>(`/assets/${id}/unwatch`)
    return res.success
  }
}
